import {Container} from "react-bootstrap";
import React, {useState, useEffect} from "react";
import {useAuth} from "../../auth/AuthProvider";
import {getLastRegisteredUsers} from "../../../lib/api/users/getLastRegisteredUsers";
import {InnerUsersList} from "./InnerUsersList";

export const LastRegisteredUsers = ({count}) => {

    const [isLoading, setIsLoading] = useState(true);
    const [usersData, setUsersData] = useState([]);

    const {token} = useAuth();

    useEffect(() => {
        if (token) {
            getLastRegisteredUsers(token, count).then(data => {
                setUsersData(data.users);
                setIsLoading(false);

            });
        }
    }, [token]);

    return (
        <Container>
            <InnerUsersList usersData={usersData} isLoading={isLoading}/>
        </Container>
    )
}